import { Flex, Tab, TabList, Tabs } from '@chakra-ui/react';
import HowItWorksDrawer from '@ui/components/HowItWorksDrawer';
import { useDefaultAppBar } from '@ui/components/MobileAppBarProvider';
import { pathDict } from '@ui/config/paths';
import { getPathInfo, useRealPathname } from '@ui/hooks/router';
import { COIN_MODE, useCoinMode } from '@ui/hooks/useCoinMode';
import { HintType } from '@ui/hooks/useShowHowItWorks';
import { useTranslations } from '@ui/i18n';
import { useRouter } from '@ui/overrides/next/router';
import type { NextPage } from 'next';

import { StakeView } from '../Stake';
import { useStakeHint } from './howItWorks';

export type StakeAndUseLcroMode = 'stake' | 'use-lcro';

export const StakeAndUseLcroView: NextPage = () => {
  const t = useTranslations();
  const router = useRouter();
  const realPathname = useRealPathname();
  const pathInfo = getPathInfo(realPathname);
  const coinMode = useCoinMode();
  const coinModeInfo = COIN_MODE[coinMode];
  const modes = [
    {
      mode: 'stake' as const,
      text: t('Stake {coin}', {
        coin: coinModeInfo.name,
      }),
      routePath: coinMode === 'cro' ? pathDict.cro.stake : pathDict.atom.stake,
    },
    {
      mode: 'use' as const,
      text: t('Use {coin}', {
        coin: coinModeInfo.liquidName,
      }),
      routePath:
        coinMode === 'cro' ? pathDict.cro.useLiquid : pathDict.atom.useLiquid,
    },
  ];

  useDefaultAppBar();

  return (
    <Flex flexGrow={1} flexDirection="column">
      <HowItWorksDrawer hintType={HintType.STAKE} {...useStakeHint()} />
      <Tabs
        mb="2px"
        index={modes.findIndex((v) => v.routePath === realPathname)}
        onChange={(index) => {
          const mode = modes[index];
          router.push(mode.routePath);
        }}
        role="heading"
        aria-label="Stake"
        aria-level={1}
      >
        <TabList>
          {modes.map((v) => {
            return <Tab key={v.mode}>{v.text}</Tab>;
          })}
        </TabList>
      </Tabs>
      {pathInfo.category === 'stake' && <StakeView />}
    </Flex>
  );
};
